import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ISearchCtx, IApiResponse, IPlanRequest, IPlanEntity } from '@mvm/api-interfaces';
import { API } from './apiutil';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class PlanService {
    http;
    constructor(http) {
        this.http = http;
    }
    readPlanById(id) {
        return this.http.get(`${environment.base}/plan/${id}`);
    }
    search(ctx) {
        return this.http.get(`${environment.base}/plan/`, { params: API.makeParams(ctx) });
    }
    createPlan(plan) {
        return this.http.post(`${environment.base}/plan`, plan);
    }
    deletePlan(id) {
        return this.http.delete(`${environment.base}/plan/${id}`);
    }
    setWorkDone(planItemId) {
        return this.http.put(`${environment.base}/plan/item/${planItemId}/done`, undefined);
    }
    setWorkNotDone(planItemId) {
        return this.http.put(`${environment.base}/plan/item/${planItemId}/not-done`, undefined);
    }
    static ɵfac = function PlanService_Factory(t) { return new (t || PlanService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanService, factory: PlanService.ɵfac });
}
